/* Pre-fills the contact form message from a ?product= query param.
   Used by the freight "Contact us for a shipping quote" CTA (PDP + cards) —
   see snippets/buy-buttons.liquid and snippets/k-card-product.liquid.
   Dawn's floating label handles the filled state via :placeholder-shown. */
(function () {
  var product = new URLSearchParams(window.location.search).get('product');
  if (!product) return;
  var body = document.getElementById('ContactForm-body');
  if (!body || body.value.trim() !== '') return;
  body.value =
    'Shipping quote request for: ' + product + '\n\nDelivery ZIP code: \n';
})();
